import { render, staticRenderFns } from "./CreateSavedFilterIcon.vue?vue&type=template&id=b4b02226&scoped=true"
import script from "./CreateSavedFilterIcon.vue?vue&type=script&lang=js"
export * from "./CreateSavedFilterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b02226",
  null
  
)

export default component.exports